import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { canPerformAnyAction } from '~src/resourceActions/selectors/ResourceActionsSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { removeSiteUsersFromGroup } from '../../groups/actions/GroupMenuActions';
import { IGroupInfo } from '../../groups/models/IGroupInfo';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserRemoveFromGroupAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemoveFromGroup,
  translateName: Messages.remove_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    const group = state.spaceInfo.item as IGroupInfo;
    const passesCommonChecks = targetItems.length > 0
      && !isSingleSelectSiteUserGuest(targetItems)
      && state.spaceInfo.spaceType === 'group'
      && !group.isAllUsersGroup;

    const hasAccess = SessionUserSelectors.canManageUsers(state)
      || (SessionServerSelectors.isAdminProfilesEnabledOnServer(state) && canPerformAnyAction(state, 'User', ['CHANGE_GROUP_MEMBERSHIP']));

    return passesCommonChecks && hasAccess;
  },
  isClickable: (_availableActions: {}, _targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => removeSiteUsersFromGroup(targetItems)
};
